/**
 * A rate with no taxable value is taxable, which keeps rates saved before the
 * checkbox working as before. Tax rates are the other way around: charging tax
 * on a tax line is rare, so it only happens when the box is ticked.
 */
export function isRateTaxable(
  rate: { taxable?: boolean | null },
  isTaxRate: boolean
): boolean {
  return isTaxRate ? rate.taxable === true : rate.taxable !== false;
}
